import { HTTP_API_V2 } from '../../http-common'

export default {
  state: {
    loadedApiVersion: {},
    loadedWebVersion: {},
    loadingApiVersion: false,
    loadingWebVersion: false
  },
  getters: {
    loadedApiVersion (state) {
      return state.loadedApiVersion
    },
    loadedWebVersion (state) {
      return state.loadedWebVersion
    },
    loadingApiVersion (state) {
      return state.loadingApiVersion
    },
    loadingWebVersion (state) {
      return state.loadingWebVersion
    }
  },
  mutations: {
    setLoadedApiVersion (state, payload) {
      state.loadedApiVersion = payload
    },
    setLoadedWebVersion (state, payload) {
      state.loadedWebVersion = payload
    },
    setLoadingApiVersion (state, trueFalse) {
      state.loadingApiVersion = trueFalse
    },
    setLoadingWebVersion (state, trueFalse) {
      state.loadingWebVersion = trueFalse
    }
  },
  actions: {
    loadApiVersion ({ commit }) {
      commit('setLoading', true)
      commit('setLoadingApiVersion', true)
      commit('setLoadedApiVersion', {})

      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('version?t=' + Date.now(), { // cache-bust
          baseURL: HTTP_API_V2.defaults.baseURL.replace('v2', '')
        })
          .then(result => {
            commit('setLoadedApiVersion', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
            commit('setLoadingApiVersion', false)
          })
      })
    },
    loadWebVersion ({ commit }) {
      commit('setLoading', true)
      commit('setLoadingWebVersion', true)
      commit('setLoadedWebVersion', {})

      return new Promise((resolve, reject) => {
        fetch('/static/version.json?t=' + Date.now()) // cache-bust
          .then(fileContent => {
            fileContent.json()
              .then(versionObject => {
                commit('setLoadedWebVersion', versionObject)
                resolve(versionObject)
              })
          })
          .catch(err => {
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
            commit('setLoadingWebVersion', false)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/version/index.js